import { useAuthStore } from '@metras/frontend-shared/stores/auth.store'

const AUTH_HEADER_NAMES = ['authorization', 'x-standard-name']

export const formioAuthPlugin = {
  priority: 0,
  requestOptions(options: { headers?: Record<string, string> }, url: string) {
    if (!url.startsWith(new URL(import.meta.env.VITE_API_ROOT).origin)) {
      return options
    }

    const { accessToken, standard } = useAuthStore()

    if (!accessToken) {
      return options
    }

    const headers = Object.fromEntries(Object.entries(options.headers ?? {}).filter(([name]) => !AUTH_HEADER_NAMES.includes(name.toLowerCase())))

    return {
      ...options, headers: {
        ...headers, Authorization: `Bearer ${accessToken}`, 'x-standard-name': standard
      }
    }
  }
}
